
/**
 * 日德（又称干德）：甲己日寅，乙庚日申，丙辛日巳，丁壬日亥，戊癸日巳。
 */
export const riDe = {
    "甲": "寅",
    "乙": "申",
    "丙": "巳",
    "丁": "亥",
    "戊": "巳",
    "己": "寅",
    "庚": "申",
    "辛": "巳",
    "壬": "亥",
    "癸": "巳"
}
/**
 * 甲禄在寅、乙禄在卯、丙禄在巳、丁禄在午、戊禄在巳、己禄在午、庚禄在申、辛禄在酉、壬禄在亥、癸禄在子。
 */
export const riLu = {
    "甲": "寅",
    "乙": "卯",
    "丙": "巳",
    "丁": "午",
    "戊": "巳",
    "己": "午",
    "庚": "申",
    "辛": "酉",
    "壬": "亥",
    "癸": "子"
}

/**
 * 生气：正月在子 顺行 十二
 */
export const ShengQi = {
    "寅": "子",
    "卯": "丑",
    "辰": "寅",
    "巳": "卯",
    "午": "辰",
    "未": "巳",
    "申": "午",
    "酉": "未",
    "戌": "申",
    "亥": "酉",
    "子": "戌",
    "丑": "亥"
}
/**
 * 死气：正月起午 顺行 十二
 */
export const SiQi = {
    "寅": "午",
    "卯": "未",
    "辰": "申",
    "巳": "酉",
    "午": "戌",
    "未": "亥",
    "申": "子",
    "酉": "丑",
    "戌": "寅",
    "亥": "卯",
    "子": "辰",
    "丑": "巳"
}

/**
 * 破碎：孟日在酉，仲日在巳，季日在丑
 */
export const PoSui = {
    "寅": "酉", "申": "酉", "巳": "酉", "亥": "酉",
    "子": "巳", "午": "巳", "卯": "巳", "酉": "巳",
    "辰": "丑", "戌": "丑", "丑": "丑", "未": "丑"
}

/**
 * 天德：正丁二申庚，三壬四辛同，五癸亥六甲，七癸八甲寅，九丙十居乙，子巳丑庚中。
 * 月支 -> 天德 (干或支)
 * 注：五月天德，口诀“五癸亥”，此处取“亥”；八月“八甲寅”，此处取“寅”。
 * 若需兼容多重定义，可自行调整。
 */
export const TianDe = {
    "寅": "丁",
    "卯": "申",
    "辰": "壬",
    "巳": "辛",
    "午": "亥",
    "未": "甲",
    "申": "癸",
    "酉": "寅",
    "戌": "丙",
    "亥": "乙",
    "子": "巳",
    "丑": "庚"
}

/**
 * 月德：寅午戌月在丙，亥卯未月在甲，申子辰月在壬，巳酉丑月在庚。
 */
export const YueDe = {
    "寅": "丙", "午": "丙", "戌": "丙",
    "亥": "甲", "卯": "甲", "未": "甲",
    "申": "壬", "子": "壬", "辰": "壬",
    "巳": "庚", "酉": "庚", "丑": "庚"
}

/**
 * 天马：正七午，二八申，三九戌，四十子，五十一寅，六腊辰。
 */
export const TianMa = {
    "寅": "午", "申": "午",
    "卯": "申", "酉": "申",
    "辰": "戌", "戌": "戌",
    "巳": "子", "亥": "子",
    "午": "寅", "子": "寅",
    "未": "辰", "丑": "辰"
}

/**
 * 天喜：春季见戌亥子，夏季见丑寅卯，秋季见辰巳午，冬季见未申酉。
 * 对应：寅->戌, 卯->亥, 辰->子 ...
 */
export const TianXi = {
    "寅": "戌", "卯": "亥", "辰": "子",
    "巳": "丑", "午": "寅", "未": "卯",
    "申": "辰", "酉": "巳", "戌": "午",
    "亥": "未", "子": "申", "丑": "酉"
}

/**
 * 天医：正月戌，二月亥，顺推至十二月酉。
 */
export const TianYi = {
    "寅": "戌", "卯": "亥", "辰": "子",
    "巳": "丑", "午": "寅", "未": "卯",
    "申": "辰", "酉": "巳", "戌": "午",
    "亥": "未", "子": "申", "丑": "酉"
}
// 注：天喜与天医在口诀上的排布似乎一致（正月戌...）。

/**
 * 劫煞：申子辰见巳，巳酉丑见寅，寅午戌见亥，亥卯未见申。
 * Key为三合局的任一支
 */
export const JieSha = {
    "申": "巳", "子": "巳", "辰": "巳",
    "巳": "寅", "酉": "寅", "丑": "寅",
    "寅": "亥", "午": "亥", "戌": "亥",
    "亥": "申", "卯": "申", "未": "申"
}

/**
 * 丧车：春酉，夏子，秋卯，冬午。
 */
export const SangChe = {
    "寅": "酉", "卯": "酉", "辰": "酉",
    "巳": "子", "午": "子", "未": "子",
    "申": "卯", "酉": "卯", "戌": "卯",
    "亥": "午", "子": "午", "丑": "午"
}

/**
 * 飞廉：正月戌，二月巳，三月午，四月未... 顺推
 * 寅->戌, 卯->巳, 辰->午, 巳->未, 午->申, 未->酉, 申->戌, 酉->亥, 戌->子, 亥->丑, 子->寅, 丑->卯
 */
export const FeiLian = {
    "寅": "戌",
    "卯": "巳",
    "辰": "午",
    "巳": "未",
    "午": "申",
    "未": "酉",
    "申": "戌",
    "酉": "亥",
    "戌": "子",
    "亥": "丑",
    "子": "寅",
    "丑": "卯"
}

/**
 * 四丘：春丑，夏辰，秋未，冬戌。
 */
export const SiQiu = {
    "寅": "丑", "卯": "丑", "辰": "丑",
    "巳": "辰", "午": "辰", "未": "辰",
    "申": "未", "酉": "未", "戌": "未",
    "亥": "戌", "子": "戌", "丑": "戌"
}

/**
 * 四墓：春未，夏戌，秋丑，冬辰。
 */
export const SiMu = {
    "寅": "未", "卯": "未", "辰": "未",
    "巳": "戌", "午": "戌", "未": "戌",
    "申": "丑", "酉": "丑", "戌": "丑",
    "亥": "辰", "子": "辰", "丑": "辰"
}

/**
 * 天鬼：春酉，夏子，秋卯，冬午。
 */
export const TianGui = {
    "寅": "酉", "卯": "酉", "辰": "酉",
    "巳": "子", "午": "子", "未": "子",
    "申": "卯", "酉": "卯", "戌": "卯",
    "亥": "午", "子": "午", "丑": "午"
}
